/**
 * What the browser can record, and how long it may go on for.
 *
 * MediaRecorder gives webm/opus on Chrome and Firefox and mp4/aac on Safari,
 * and neither is what the phone plays — the API transcodes whatever arrives
 * (7.4). The list is in preference order and the first supported one wins.
 */
const RECORDING_TYPES = [
  "audio/webm;codecs=opus",
  "audio/webm",
  "audio/mp4",
  "audio/ogg;codecs=opus",
];

/**
 * A caller is standing at a payphone, so two minutes is already longer than
 * anyone will listen. It also keeps a recording well under the size the API
 * will accept, which S3 cannot refuse at upload time.
 */
export const MAX_RECORDING_SECONDS = 120;

/** The type this browser will record in, or null if it will not record at all. */
export function supportedRecordingType(): string | null {
  const recorder = globalThis.MediaRecorder;
  if (!recorder || !navigator.mediaDevices?.getUserMedia) return null;
  return RECORDING_TYPES.find((type) => recorder.isTypeSupported(type)) ?? null;
}

/** Preview audio comes back in the response body rather than from the bucket. */
export function audioDataUrl(base64: string, contentType: string): string {
  return `data:${contentType};base64,${base64}`;
}

/** A count of seconds as mm:ss, for the recording timer. */
export function clock(value: number): string {
  const whole = Math.floor(value);
  return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, "0")}`;
}
